module.exports = __webpack_public_path__ + "media/components/home/unlock-vecteezy/img/find-your-path-mobile-video-3d33c89d5aa050ab2f6f5d534c5707de.jpg";